import { TriggerHistoryElement } from './TriggerHistoryElement';

export class ListTriggerElement extends TriggerHistoryElement {
  constructor() {
    super();
  }
}
